module.exports = __webpack_public_path__ + "img/WALK-SUPPORT-05.7b2b2bf8.png";